/**
 * A escolha de operadores do Histórico de atendimentos.
 *
 * "Permitir selecionar mais de um operador" (Gisele, 28/10/2026). Era um id
 * só; virou lista, e duas regrinhas precisam ficar presas:
 *
 * 1. **a lista nunca fica vazia.** Lista vazia a api lê como "o meu
 *    histórico" -- e aí o seletor em branco mostraria o histórico de alguém
 *    sem dizer de quem;
 * 2. **a caixa fechada mostra NOMES.** Sem isso o `Select` do MUI escreve os
 *    ids, e ninguém reconhece um colega por id.
 *
 * Moram aqui, e não dentro da tela, porque a `HistoryPage` tem 1.100 linhas e
 * nenhum teste -- a regra dentro dela seria exercitável só montando a página
 * inteira.
 */

/** O rótulo do próprio usuário, que é como o seletor sempre o chamou. */
export const MEU_HISTORICO = 'Meu histórico';

/**
 * A nova seleção, recusando a lista VAZIA.
 *
 * @param {Array} escolhidos  o que o seletor devolveu
 * @param {Array} atual       o que estava escolhido
 * @returns {Array<number>} ids, ou `atual` quando a escolha esvaziaria tudo
 */
export const selecaoDeOperadores = (escolhidos, atual) => {
    const lista = (Array.isArray(escolhidos) ? escolhidos : [escolhidos])
        .filter((id) => id !== null && id !== undefined && id !== '');

    // Desmarcar o último não desmarca: devolve o que já estava.
    if (lista.length === 0) return Array.isArray(atual) ? atual : [];

    return lista.map(Number);
};

/**
 * Os operadores escolhidos, por nome, para a caixa fechada e para o resumo
 * de filtros ativos.
 *
 * O próprio usuário aparece como "Meu histórico" -- é assim que ele se vê no
 * seletor desde sempre, e trocar pelo nome dele no meio da lista faria a
 * pessoa procurar a si mesma.
 *
 * Id que não está na lista de usuários vira `#id` em vez de sumir: sumir
 * faria a caixa dizer menos operadores do que está filtrando.
 *
 * @param {Array} ids
 * @param {number|string} meuId
 * @param {Array<{id: number, name: string}>} usuarios
 * @returns {string}
 */
export const nomesDosOperadores = (ids, meuId, usuarios) => (Array.isArray(ids) ? ids : [])
    .map((id) => {
        if (String(id) === String(meuId)) return MEU_HISTORICO;

        const achado = (usuarios || []).find((u) => String(u?.id) === String(id));

        return achado?.name || `#${id}`;
    })
    .join(', ');

/** Só o meu histórico -- o estado inicial, e o "sem filtro de operador". */
export const ehSoMeuHistorico = (ids, meuId) => Array.isArray(ids)
    && ids.length === 1
    && String(ids[0]) === String(meuId);
